import styles from './StatCard.module.css';

function StatCard({ label, value, icon: Icon }) {
  return (
    <div className={`${styles.card} h-100 p-4`}>
      <div className="d-flex align-items-start justify-content-between gap-3">
        <span className={styles.label}>{label}</span>
        <span className={`${styles.iconBox} d-flex align-items-center justify-content-center flex-shrink-0`}>
          <Icon size={20} strokeWidth={2} aria-hidden="true" />
        </span>
      </div>
      <p className={`${styles.value} mb-0 mt-3`}>{value}</p>
    </div>
  );
}

export default StatCard;
